<script>
	export let cls = null
</script>

<tr class="border-b border-b-neutral-300 {cls ?? ''}">
	<slot />
</tr>
